// extracted by css-extract-rspack-plugin
export default {"dropdown":"Dropdown-module__dropdown--F6juD","wrapper":"Dropdown-module__wrapper--IxsNu"};